<div class="toast">
    <div class="icon">
        <img src="assets/img/warning.png" alt="error">
    </div>
    <span class="message">{{data?.msg || 'Something went wrong!'}}</span>
</div>